import { render, staticRenderFns } from "./ISupport.vue?vue&type=template&id=87f73fee&"
import script from "./ISupport.vue?vue&type=script&lang=ts&"
export * from "./ISupport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports